import React from "react"

import { Checkbox } from "@mui/material"
import { Cell, Row } from "components/common/table/basicTable"
import { useTranslation } from "react-i18next"
import { TypographyHead, visuallyHiddenSx } from "styles/common/typography"

interface HeadAllTransactionsProps {
  onChange: () => void
  isChecked: boolean
  isIndeterminate: boolean
  isDisabled: boolean
}

const HeadAllTransactions = ({
  onChange,
  isChecked,
  isIndeterminate,
  isDisabled,
}: HeadAllTransactionsProps) => {
  const { t } = useTranslation()
  return (
    <>
      <Row>
        <Cell tableCellProps={{ width: "48px", sx: { p: 0 } }} px={0}>
          <Checkbox
            checked={isChecked}
            onChange={onChange}
            indeterminate={isIndeterminate}
            disabled={isDisabled}
            slotProps={{
              input: {
                "aria-label": t("allTransactions.selectAllTransactions"),
              },
            }}
          />
        </Cell>
        <Cell tableCellProps={{ width: "80px" }}>
          <TypographyHead>{t("allTransactions.type")}</TypographyHead>
        </Cell>
        <Cell>
          <TypographyHead>
            {t("allTransactions.classAndTeacher")}
          </TypographyHead>
        </Cell>
        <Cell tableCellProps={{ width: "17%" }}>
          <TypographyHead>{t("allTransactions.student")}</TypographyHead>
        </Cell>
        <Cell tableCellProps={{ width: "22%" }}>
          <TypographyHead>{t("allTransactions.title")}</TypographyHead>
        </Cell>
        <Cell>
          <TypographyHead>{t("allTransactions.date")}</TypographyHead>
        </Cell>
        <Cell tableCellProps={{ width: "10%" }}>
          <TypographyHead>{t("allTransactions.amount")}</TypographyHead>
        </Cell>
        <Cell tableCellProps={{ width: "48px", sx: { p: 0 } }} px={0}>
          <TypographyHead sx={visuallyHiddenSx}>
            {t("allTransactions.actions")}
          </TypographyHead>
        </Cell>
      </Row>
    </>
  )
}

export default HeadAllTransactions
